import {
  Card,
  Image,
  Modal,
  Row,
  Col,
  Typography,
  Spin,
  Empty,
  Pagination,
} from 'antd';
import { useGetMediaAssets } from '@/shared/api';
import { usePaging } from '@/shared/hooks';
import { Backdrop } from '@/shared/ui';

interface ImageLibraryModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (imageUrl: string, id: string) => void;
  fileIds?: string[];
}

const PAGE_SIZE_OPTIONS = [12, 24, 48];

export const ImageLibraryModal = ({
  open,
  onClose,
  onSelect,
  fileIds = [],
}: ImageLibraryModalProps) => {
  const { page, pageSize, pageSizeOptions, onPagingChange } = usePaging({
    pageSizeOptions: PAGE_SIZE_OPTIONS,
  });
  const {
    data: assets,
    isFetching,
    isInitialLoading,
  } = useGetMediaAssets(
    { queryParams: { fileId: fileIds, take: pageSize, page } },
    { keepPreviousData: true, enabled: open && !!fileIds?.length },
  );
  const noData = !fileIds?.length || (!assets?.data && !isInitialLoading);

  return (
    <Modal
      title="Image Library"
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {isFetching && (
        <Backdrop>
          <Spin />
        </Backdrop>
      )}
      {noData && (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No media assets in the library"
        />
      )}
      <Row gutter={[16, 16]} style={{ minHeight: 250 }}>
        {assets?.data.map((image) => (
          <Col key={image.url} xs={24} sm={12} md={8} lg={6}>
            <Card
              hoverable
              cover={
                <div style={{ height: 150, overflow: 'hidden' }}>
                  <Image
                    alt={image.originalName}
                    src={image.url}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                    preview={false}
                  />
                </div>
              }
              onClick={() => onSelect(image.url, image.id)}
              style={{ cursor: 'pointer', height: '100%' }}
            >
              <Card.Meta
                title={
                  <Typography.Text ellipsis style={{ width: '100%' }}>
                    {image.originalName}
                  </Typography.Text>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>
      <Pagination
        hideOnSinglePage
        showSizeChanger
        style={{ textAlign: 'center' }}
        disabled={isFetching}
        total={assets?.meta.itemCount}
        current={page}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        onChange={onPagingChange}
      />
    </Modal>
  );
};
